import BaseModal, { BaseModalProps } from "#/ui/Modal/BaseModal"

import { ClaimingFailedBody } from "./ClaimRewards"

export default function ErrorOnMatsClaimModal({
  isOpen,
  onClose,
}: BaseModalProps) {
  return (
    <BaseModal isOpen={isOpen} onClose={onClose} closeable>
      <ClaimingFailedBody
        onClose={() => onClose?.({ closeSource: "closeButton" })}
        suggestSupport
      />
    </BaseModal>
  )
}
